/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn } from "@/lib/utils";
import apiRoutes from "@/src/apiRoutes";
import { Button } from "@/src/components/Button/Button";
import Stepper from "@/src/components/stepper";
import { textVariants } from "@/src/components/Text/Text";
import { SurveyInfo } from "@/src/layouts/Dashboard/types";
import api, { sanitizeKey } from "@/src/utils";
import logo from "@assets/mbs-logo-gray-bg.png";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { QuestionComponent } from "./components/questions";
import _ from "lodash";

interface Props {
  survey: SurveyInfo | undefined;
}

const Surveys = ({ survey }: Props) => {
  const [step, setStep] = useState(0);
  const form = useForm();
  const queryClient = useQueryClient();
  const [errors, setErrors] = useState("");

  console.log(form.getValues());

  const submitSurvey = async () => {
    const res = await api.post(apiRoutes.completeSurvey, {
      survey_id: survey?.data.id,
      type: "complete",
      answers: Object.entries(form.watch()).map(([, value], index) => {
        return {
          question: survey?.data.questions[index].question,
          answer: value ?? "",
        };
      }),
    });
    return res.data;
  };

  const { mutate, isLoading } = useMutation({
    mutationFn: submitSurvey,
    onSuccess: (data) => {
      if (data?.success) {
        toast.success(data?.info);
        queryClient.invalidateQueries({ queryKey: ["check_enablers_survey"] });
        window.location.reload();
      } else {
        toast.warning(data?.info);
      }
    },
  });
  const skipSurvey = async () => {
    const res = await api.post(apiRoutes.completeSurvey, {
      survey_id: survey?.data.id,
      type: "skip",
    });
    return res.data;
  };

  const { mutate: skip, isLoading: skipLoad } = useMutation({
    mutationFn: skipSurvey,
    onSuccess: (data) => {
      if (data?.success) {
        toast.success(data?.info);
        queryClient.invalidateQueries({ queryKey: ["check_enablers_survey"] });
        window.location.reload();
      } else {
        toast.warning(data?.info);
      }
    },
  });

  const renderQuestions = survey?.data.questions.map((question, index) => (
    <QuestionComponent
      key={index}
      question={question}
      form={form}
      errors={errors}
    />
  ));

  function stepChange() {
    if (step === 0) {
      setStep(1);
      return;
    }
    if (
      !survey?.data.questions[step - 1]?.optional &&
      _.isEmpty(
        form.watch(
          sanitizeKey(survey?.data.questions[step - 1]?.question as string)
        )
      )
    ) {
      // console.log(survey?.data.questions[step - 1]?.question as string);
      // console.log("err", form.watch());
      setErrors("This field is required");
    } else {
      if (step === survey?.data.questions.length) {
        mutate();
      } else {
        setStep(step + 1);
      }
      setErrors("");
    }
  }

  return (
    <div>
      <div className="w-full flex items-center justify-center">
        <img src={logo} alt="logo" className="w-12 h-12 " />
      </div>
      <div className="w-full flex mt-3">
        <Stepper
          totalSteps={survey?.data.questions.length ?? 0}
          items={[
            <span
              className={cn(
                "text-center w-full",
                textVariants({ font: "bold" })
              )}
            >
              {survey?.data.title}
            </span>,
            ...(renderQuestions as any),
          ]}
          currentStep={step}
        />
      </div>

      <div className="flex flex-row items-end justify-end mt-10 gap-3">
        {!survey?.data.required && step === 0 && (
          <Button
            onClick={() => skip()}
            loading={skipLoad}
            className="bg-gray-300 text-black"
            variant={"primary"}
          >
            Skip
          </Button>
        )}
        {step !== Number(survey?.data.questions.length) ? (
          <Button onClick={stepChange}>
            {step === 0 ? "Proceed" : "Next"}
          </Button>
        ) : (
          <Button onClick={stepChange} loading={isLoading}>
            Submit
          </Button>
        )}
      </div>
    </div>
  );
};

export default Surveys;
